import React, { useState } from 'react';
import "./NavigationBar.css"
import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '/backend';

function BuyButton(props) {
    const [checkout, setCheckout] = useState();
    const [checkoutError, setCheckoutError] = useState("");

    const style = {
      borderStyle: 'hidden',
    }

    async function buyFunction(){
        try {
          setCheckoutError("");
          const resolve = await axios.post(`${apiBaseUrl}/paymentLinkCreator`, props.cart, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          setCheckout(resolve.data)
        }
        catch (error) {
          setCheckout();
          setCheckoutError("Demo checkout could not be created.");
        }
      }

      return (
            <div>
              <button onClick={buyFunction} style={style}>Demo Checkout</button>
              {checkout ? (
                <div className="DemoCheckout">
                  <p>{checkout.message}</p>
                  <p>Order: {checkout.orderId}</p>
                  <p>Total: ${checkout.total}</p>
                </div>
              ) : <></>}
              {checkoutError ? <p className="DemoCheckoutError">{checkoutError}</p> : <></>}
            </div>
      );
    }
    
    export default BuyButton;
